<template>
  <div>
    <Loader v-if="initalLoad" class="loader" />
    <SmFilter
      v-else
      :selectCounter="selectCounter"
      :clearble="!isDefault"
      @clear="resetFilters"
    >
      <div class="appointment-filter">
        <div class="appointment-filter--up">
          <ClinicFilter
            v-model="clinicSelected"
            :items="clinicList"
            :clearble="defaultState['clinicIds']"
            @submit="() => submitHandler('clinicIds', clinicSelected)"
            @reset-filter="() => resetFilter('clinicIds')"
          />
          <DateFilter
            v-model="dateSelected"
            title="Дата приёма"
            @submit="() => submitHandler('dates', dateSelected)"
            @reset-filter="() => resetFilter('dates')"
          />
          <SelectFilter
            v-model="specialitiesSelected"
            title="Специальность"
            itemTitle="name"
            :items="specialitiesList"
            :clearble="defaultState['specialityIds']"
            @submit="() => submitHandler('specialityIds', specialitiesSelected)"
            @reset-filter="() => resetFilter('specialityIds')"
          />
        </div>
        <div class="appointment-filter--down">
          <DoctorFilter
            v-model="doctorSelected"
            :items="doctorList"
            :clearble="defaultState['doctorIds']"
            @submit="() => submitHandler('doctorIds', doctorSelected)"
            @reset-filter="() => resetFilter('doctorIds')"
          />
          <RadioFilter
            v-model="genderSelected"
            :items="genderList"
            @submit="() => submitHandler('gender', genderSelected)"
          />
        </div>
      </div>
    </SmFilter>
  </div>
</template>
<script>
import { onMounted, ref, toRefs, watch } from '@vue/composition-api'
import { omitByNull } from '@/core/utils'
import { useStore } from '@/store'
import { useDisplay } from '@/hooks'
import { mergeUniqueArrays } from '@/core/helpers'

import { SmFilter } from '@/components/smFilters/components'
import Loader from '@/components/loader'

import {
  ClinicFilter,
  DateFilter,
  DoctorFilter,
  RadioFilter,
  SelectFilter
} from '../components'
import useFilter from '../hooks/useFilter'

export default {
  name: 'VisitsFilter',
  components: {
    ClinicFilter,
    DateFilter,
    RadioFilter,
    SmFilter,
    SelectFilter,
    DoctorFilter,
    Loader
  },
  props: ['initState', 'finished'],
  setup(props, ctx) {
    const { initState } = toRefs(props)
    const display = useDisplay()
    const store = useStore()

    const initalLoad = ref(true)
    const isDefault = ref(true)
    const selectCounter = ref(0)
    const defaultState = ref({})

    const clinicList = ref([])
    const clinicSelected = ref([])

    const specialitiesList = ref([])
    const specialitiesSelected = ref([])

    const doctorList = ref([])
    const doctorSelected = ref([])

    const genderList = ['Любой', 'Мужской', 'Женский']
    const genderSelected = ref(initGender())

    const dateSelected = ref(null)

    watch(genderSelected, () => {
      if (display.value.smAndDown) return
      submitHandler('gender', genderSelected.value)
    })

    function initGender() {
      if (initState.value.doctorSex === 'MALE') return 'Мужской'
      if (initState.value.doctorSex === 'FEMALE') return 'Женский'
      return 'Любой'
    }

    function submitHandler(id, value) {
      switch (id) {
        case 'dates':
          ctx.emit('submit', { id, value })
          break
        case 'gender': {
          let result = null

          if (value === 'Мужской') {
            result = 'MALE'
          }

          if (value === 'Женский') {
            result = 'FEMALE'
          }

          ctx.emit('submit', {
            id: 'doctorSex',
            value: result
          })
          break
        }
        default:
          ctx.emit('submit', { id, value: value.map((v) => v.id) })
      }
    }

    function resetFilter(type) {
      ctx.emit('reset', type)
    }

    function resetFilters() {
      ctx.emit('reset-all-filters')
    }

    onMounted(async () => {
      const payload = omitByNull({
        specialityIds: initState.value.specialityIds,
        doctorIds: initState.value.doctorIds,
        clinicIds: initState.value.clinicIds,
        dates: initState.value.dates,
        from: initState.value.from,
        to: initState.value.to,
        doctorSex: initState.value.doctorSex,
        status: props.finished ? 'FINISHED' : 'UPCOMING'
      })

      await store.dispatch('visits/getVisitsFilters', payload)

      const filterConfig = [
        {
          id: 'clinicIds',
          initial: initState.value.clinicIds,
          list: store.getters['visits/visitsFilterData'].clinics
        },
        {
          id: 'specialityIds',
          initial: initState.value.specialityIds,
          list: store.getters['visits/visitsFilterData'].specialities
        },
        {
          id: 'doctorIds',
          initial: initState.value.doctorIds,
          list: store.getters['visits/visitsFilterData'].doctors
        }
      ]

      const {
        list,
        selected,
        isDefault: _isDefault,
        selectCounter: _selectCounter,
        defaultState: _defaultState
      } = useFilter(filterConfig)

      clinicList.value = list['clinicIds']
      clinicSelected.value = selected['clinicIds']

      specialitiesList.value = list['specialityIds']
      specialitiesSelected.value = selected['specialityIds']

      doctorList.value = list['doctorIds']
      doctorSelected.value = selected['doctorIds']

      isDefault.value = _isDefault
      selectCounter.value = _selectCounter
      defaultState.value = _defaultState

      const filterInitState = store.getters['filter/getInitState']
      let filterStash = null

      const STATE_NAME = props.finished ? 'FINISHED' : 'UPCOMING'
      if (!filterInitState?.[STATE_NAME]) {
        const visits = {
          clinicList: clinicList.value,
          doctorList: doctorList.value,
          specialitiesList: specialitiesList.value
        }
        store.commit('filter/setInitState', { [STATE_NAME]: visits })
        filterStash = store.getters['filter/getInitState']
      } else {
        filterStash = filterInitState[STATE_NAME]
      }

      if (initState.value.clinicIds) {
        if (
          !initState.value.specialityIds &&
          !initState.value.doctorIds &&
          clinicList.value.length
        ) {
          clinicList.value = mergeUniqueArrays(
            clinicList.value,
            filterStash.clinicList,
            'id'
          )
        }
      }

      if (initState.value.doctorIds) {
        if (
          !initState.value.clinicIds &&
          !initState.value.specialityIds &&
          doctorList.value.length
        ) {
          doctorList.value = mergeUniqueArrays(
            doctorList.value,
            filterStash.doctorList,
            'id'
          )
        }
      }

      if (initState.value.specialityIds) {
        if (
          !initState.value.clinicIds &&
          !initState.value.doctorIds &&
          specialitiesList.value.length
        ) {
          specialitiesList.value = mergeUniqueArrays(
            specialitiesList.value,
            filterStash.specialitiesList,
            'id'
          )
        }
      }

      if (initState.value.dates) {
        isDefault.value = false
        selectCounter.value++
        dateSelected.value = {
          calendarMode: 'mulitiple',
          value: initState.value.dates
        }
      }

      if (initState.value.from && initState.value.to) {
        isDefault.value = false
        selectCounter.value++
        dateSelected.value = {
          calendarMode: 'range',
          value: {
            start: initState.value.from,
            end: initState.value.to
          }
        }
      }

      if (initState.value.doctorSex) {
        isDefault.value = false
      }

      initalLoad.value = false
    })

    return {
      doctorList,
      specialitiesList,
      clinicList,
      genderList,
      doctorSelected,
      specialitiesSelected,
      clinicSelected,
      genderSelected,
      dateSelected,
      isDefault,
      defaultState,
      selectCounter,
      submitHandler,
      resetFilters,
      resetFilter,
      display,
      initalLoad
    }
  }
}
</script>
<style lang="scss" scoped>
@import 'style';
</style>
